export const SERVICE_NAME = 'ペットライフサポート プロジェクト';
export const REGISTER_FORM_URL =
  'https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=vP34RyYFZ0mfFfJIcFylis0aZVB5CtBEg7IKOBJA2E9UMjNEN0hKVTJIWEFLQlRSSTVORVcyS1A4Ri4u';
export const CONTACT_FORM_URL =
  'https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=vP34RyYFZ0mfFfJIcFylis0aZVB5CtBEg7IKOBJA2E9UNEhXNFhEVjdKVEg5M0FIWjRFN0FOV1hRUS4u';
